import Api from "../apiService";

class OrderInvoiceProductsApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/order_invoice_products`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/order_invoice_products/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/order_invoice_products`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/order_invoice_products/${id}`,
      data,
      Api.authHeaders()
    );
  }

  enable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/order_invoice_products/${id}/enable`,
      {},
      Api.authHeaders()
    );
  }

  disable(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/order_invoice_products/${id}/disable`,
      {},
      Api.authHeaders()
    );
  }
}

export default new OrderInvoiceProductsApi();
